import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=d643f13e&scoped=true&"
import script from "./RecycleBin.vue?vue&type=script&lang=js&"
export * from "./RecycleBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d643f13e",
  null
  
)

export default component.exports